export const mocker = {
  autoLoginParams () {
    return {
      coduser: '',
      codpswd: '',
      codapp: ''
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/autologin/mocker.js